import React from 'react';
import Link from 'next/link';
import classNames from 'classnames';

import css from './TopBar.less';

const logoDefault = require('~/static/common/brand@3x.png');
const logoLight = require('~/static/common/brand_white@3x.png');

const links = [
  { label: '关于我们', href: '/about' },
  { label: '工作机会', href: '/join' },
  { label: '商务合作', href: '/contact' },
  {
    label: '服务商入口',
    href: 'http://www.xindebaby.com/thrid/providers/',
    external: true,
  },
];

const TopBar = ({ className, isCondensed = false }) => {
  return (
    <div className={classNames(css.topBar, className, { [css.condensed]: isCondensed })}>
      <div className={css.logoWrapper}>
        <img src={isCondensed ? logoDefault : logoLight} alt="新得宝贝" className={css.logo} />
      </div>
      <nav className={css.nav}>
        {links.map(link => {
          if (link.external) {
            return (
              <a key={link.label} href={link.href} target="_blank" rel="noopener noreferrer">
                {link.label}
              </a>
            );
          }
          return (
            <Link key={link.label} href={link.href}>
              <a>{link.label}</a>
            </Link>
          );
        })}
      </nav>
    </div>
  );
};

export default TopBar;
